import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GeneralService } from '../services/general.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-avt-machine-salle',
  templateUrl: './avt-machine-salle.component.html',
  styleUrls: ['./avt-machine-salle.component.scss']
})
export class AvtMachineSalleComponent implements OnInit {

  constructor(public generalService : GeneralService, public dialogRef: MatDialogRef<AvtMachineSalleComponent>, @Inject(MAT_DIALOG_DATA) public data) { }
  Machine_Code : string;
  Machine : string;
  exist : boolean = true;
  disableBtnAjouter : boolean = false;
  ngOnInit() {
  }

  blurChamp(event)
  {
    this.Machine_Code = event;
  }
  ajouter(form : NgForm)
  {
    if(this.generalService.isNotEmpty(this.Machine_Code))
      this.dialogRef.close(this.Machine_Code);
  }
  close()
  {
    this.dialogRef.close(null);
  }
}
